import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@leroy-merlin-br/backyard-react-ui'

import Glyph from 'reactGarden/Glyph'

import { Icon } from 'lmcv/components/Icon'

import * as S from './styled'

const Info = ({ title, description, productLink, rules, giftedBy }) => {
  return (
    <Fragment>
      <Heading size="tera">{title}</Heading>
      {giftedBy && (
        <S.TextShare>
          <Icon name="gift" fill="currentColor" />
          <span>Presente de {giftedBy}</span>
        </S.TextShare>
      )}
      {description && (
        <Fragment>
          <S.Description heading>Descrição</S.Description>
          <S.Description>{description}</S.Description>
          {productLink && (
            <S.ProductLink href={productLink}>
              Veja a página do produto <Glyph glyph="arrow" direction="right" />
            </S.ProductLink>
          )}
        </Fragment>
      )}

      {rules && (
        <Fragment>
          <S.Description heading>Regras de Utilização</S.Description>
          <S.Description>{rules}</S.Description>
        </Fragment>
      )}
    </Fragment>
  )
}

Info.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  rules: PropTypes.string,
  giftedBy: PropTypes.string
}

export default Info
